export default {
  memberCard: {
    selectLeaderButton: 'Выбрать другого',
    deleteLeaderButton: 'Удалить лидера',
  },
};
